<template>
    <div>
        <div v-if="isInbound">
            <audio
                v-if="ringingInbound && onboardingUser.soundInboundCall"
                src="https://d1lil0eivvt84o.cloudfront.net/sounds/inbound-call.mp3"
                autoplay
                loop
            />
            <div>
                <call-settings
                    v-if="currentCall.callInProgress"
                ></call-settings>
                <user-call-avatar v-else :standardMap="currentCall.fromUser">
                    <div class="mt-3 text-warning">
                        <coin-badge
                            :amount="currentCall.pricePerMinute"
                            :label="
                                onboardingUser.creator
                                    ? $t('Earnings per minute')
                                    : $t('Charge per minute')
                            "
                        />
                    </div>
                </user-call-avatar>
            </div>

            <div
                class="d-flex align-items-center justify-content-around text-center py-3"
            >
                <div v-if="currentCall.endedAt">
                    <b-btn
                        @click="close"
                        data-testid="call-actions-close-inbound"
                        class="call-button call-button-large"
                        variant="light"
                    >
                        <font-awesome-icon icon="fa-light fa-times" size="2x" />
                    </b-btn>
                    <div class="small text-secondary">
                        {{ $t("Close") }}
                    </div>
                </div>
                <div v-if="!currentCall.callInProgress && !currentCall.endedAt">
                    <b-btn
                        @click="answer"
                        data-testid="call-actions-answer"
                        class="call-button call-button-large"
                        variant="success"
                    >
                        <font-awesome-icon
                            icon="fa-duotone fa-phone"
                            size="2x"
                        />
                    </b-btn>
                    <div class="small text-secondary">
                        {{ $t("Answer") }}
                    </div>
                </div>
                <div v-if="!currentCall.callInProgress && !currentCall.endedAt">
                    <b-btn
                        @click="decline"
                        data-testid="call-actions-decline"
                        class="call-button call-button-large"
                        variant="danger"
                    >
                        <font-awesome-icon
                            icon="fa-duotone fa-phone-hangup"
                            size="2x"
                        />
                    </b-btn>
                    <div class="small text-secondary">
                        {{ $t("Decline") }}
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <user-call-avatar
                v-if="!currentCall.callInProgress"
                :standardMap="currentCall.toUser"
            />

            <div
                v-if="!currentCall.callInProgress && !currentCall.endedAt"
                class="ring-progress-track"
            >
                <div :key="currentCall.id" class="ring-progress-bar" />
            </div>

            <div
                class="d-flex align-items-center justify-content-around text-center py-3"
            >
                <div v-if="currentCall.endedAt">
                    <b-btn
                        @click="close"
                        data-testid="call-actions-close-outbound"
                        class="call-button call-button-large"
                        variant="light"
                    >
                        <font-awesome-icon icon="fa-light fa-times" size="2x" />
                    </b-btn>
                    <div class="small text-secondary">
                        {{ $t("Close") }}
                    </div>
                </div>
                <div v-else>
                    <b-btn
                        @click="cancel"
                        data-testid="call-actions-cancel"
                        class="call-button call-button-large"
                        variant="danger"
                    >
                        <font-awesome-icon
                            icon="fa-duotone fa-phone-hangup"
                            size="2x"
                        />
                    </b-btn>
                    <div class="small text-secondary">
                        {{ $t("Cancel") }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

import UserCallAvatar from "@/components/user/UserCallAvatar";

export default {
    computed: {
        ...mapState("call", ["currentCall", "localStream", "remoteStream"]),
        isInbound() {
            return this.currentCall.toUser.id === this.onboardingUser.id;
        },
        canAnswer() {
            return !this.currentCall.answeredAt && this.isInbound;
        },
        // ringing state: dialog is up, hasn't been answered, hasn't been
        // ended/declined/missed/canceled. drives the chime audio's lifecycle.
        ringingInbound() {
            return (
                this.isInbound
                && !this.currentCall.callInProgress
                && !this.currentCall.endedAt
            );
        },
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    methods: {
        answer() {
            this.$store.dispatch("call/answer");
        },
        decline() {
            this.$store.dispatch("call/decline");
        },
        cancel() {
            this.$store.dispatch("call/cancel");
        },
        close() {
            this.$store.dispatch("call/close");
        },
    },
    components: {
        UserCallAvatar,
    },
};
</script>

<style scoped>
.ring-progress-track {
    height: 3px;
    width: 100%;
    background: rgba(0, 0, 0, 0.08);
    overflow: hidden;
    border-radius: 2px;
}

.ring-progress-bar {
    height: 100%;
    width: 100%;
    background: var(--primary);
    transform-origin: left center;
    animation: ring-progress-shrink 30s linear forwards;
}

@keyframes ring-progress-shrink {
    from {
        transform: scaleX(1);
    }
    to {
        transform: scaleX(0);
    }
}
</style>
